import React, { useRef, useState } from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import Arrow from './Arrow';
import Generalsidebar from './Generalsidebar';

const HelpAndSupport = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const HELPURL = 'https://thrive-mqy3.onrender.com/v1/support';
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_r1cti9j',
        'template_bx38xro',
        form.current,
        'iW-c7jNINgutvbSkn'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const sendHelpSupport = async (e) => {
    e.preventDefault();

    try {
      const helpDetails = {
        firstName: firstName,
        lastName: lastName,
        email,
        phoneNumber,
        message,
      };
      console.log('Help-Support', helpDetails);
      const HelpData = {
        method: 'POST',
        body: JSON.stringify(helpDetails),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      };

      const response = await fetch(HELPURL, HelpData);
      const data = await response.json();
      console.log('data', data);
    } catch (error) {
      console.log('something went wrong' + error);

      return;
    }
  };

  const alertUser = () => {
    localStorage.setItem('key', 'data');
    Swal.fire({
      title: 'Successful',
      text: ` Messaged sent `,
      color: '#186F65',
      confirmButtonColor: '#508D69',
      icon: 'success',
    });
  };
  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <form ref={form} onSubmit={sendEmail}>
        <div className='bg-[#D4DDCC] py-3 px-5'>
          <h1 className='text-4xl font-bold text-center text-[#295700] py-2 mb-1'>
            Help and Suppot
          </h1>
          <h2 className='font-bold text-center text-[#295700] py-1 px-2'>
            NEED TO SPEAK WITH THE TEAM ?
          </h2>
          <h3 className='text-center text-[#295700] py-1 px-2 mb-4'>
            We are just around the corner. Reach out to us anytime, anywhere.
            <br />
            Are you looking for more in-depth information, or perhaps you have
            specific questions.
          </h3>
          <div className='min-h-screen grid grid-rows-2 md:flex lg:flex gap-5'>
            <div className='w-full md:w-full lg:w-1/2 bg-no-repeat rounded-lg shadow-lg shadow-[#2A3D19]'>
              <img
                src='https://res.cloudinary.com/dzqx4v0al/image/upload/v1700576558/help_hnmz9k.jpg'
                alt='pic'
              />
            </div>
            <div className='w-full md:w-full lg:w-1/2 bg-[#DCAE96] py-10 px-8 rounded-lg shadow-md shadow-[#295700]'>
              <p className='text-[#295700] font-bold mb-4'>
                Please enter your details and we will get in touch as soon as
                possible
              </p>
              <form id='contact-form'>
                <div className='grid grid-cols-2 gap-5 mb-10'>
                  <input
                    type="text"
                    id="fname"
                    className=" border border-[#2A3D19] block w-full rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2"
                    placeholder="Enter your first name"
                    required
                  />
                  <input
                    type="text"
                    id="lname"
                    className=" border border-[#2A3D19] block w-full rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2"
                    placeholder="Enter your last name"
                    required
                  />
                </div>
                <div className='grid grid-cols-2 mb-10 gap-5'>
                  <input
                    type="email"
                    id="email"
                    className=" border border-[#2A3D19] block w-full rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2"
                    placeholder="Jonahmichael@yahaoo.com"
                    required
                  />
                  <input
                    type="number"
                    id="number"
                    className=" border border-[#2A3D19] block w-full rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2"
                    placeholder="Phone Number"
                    required
                  />
                </div>
                <div className='mb-5'>
                  <textarea
                    id="comment"
                    className=" border border-[#2A3D19] block rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2 w-full h-[200px]"
                    placeholder="Type your message"
                    required
                  />
                </div>
                <div className='mb-10'>
                  <input
                    type='checkbox'
                    id
                    className=" border border-[#2A3D19] rounded-md shadow-lg shadow-[#2A3D19] py-1 px-2"
                    required
                  />
                  <span className='text-[#295700]'>
                    I accept the Terms and Condition
                  </span>
                </div>
                <button
                  onClick={alertUser}
                  className="bg-[#295700]  border border-[#2A3D19] block rounded-md shadow-lg shadow-[#2A3D19] py-2 px-3 w-full hover:bg-green-500 text-white"
                  onclick=""
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </form>
      <Footer />
    </div>
  );
};

export default HelpAndSupport;
